import { FC, ReactNode } from "react";
import { useSettings } from "@components/settings/SettingsProvider";
import { CommandItem, CommandItemProps } from "./CommandItem";

interface SettingsCommandItemProps extends CommandItemProps {
    path?: string;
    onSelected(): void;
    keywords?: string[];
    shortcut?: string[];
    children: ReactNode;
    // For entity-specific valid path override
    validPathOverride?: string;
}

export const SettingsCommandItem: FC<SettingsCommandItemProps> = ({
    path,
    onSelected,
    keywords,
    shortcut,
    children,
    validPathOverride,
    ...props
}) => {
    const { validPaths } = useSettings();
    const checkPath = validPathOverride ?? path;
    if (checkPath && !validPaths.includes(checkPath)) {
        return null;
    }
    return (
        <CommandItem
            onSelect={onSelected}
            keywords={keywords}
            shortcut={shortcut}
            {...props}
        >
            {children}
        </CommandItem>
    );
};
